import React, { useEffect, useState } from 'react';
import { Stack } from '@fluentui/react';
import { IPersonaSharedProps, Persona, PersonaSize } from '@fluentui/react/lib/Persona';
import { Icon } from '@fluentui/react/lib/Icon';
import { graphInstance } from '../../../index';
import MSGraphService from '../../../services/MSGraphService';
import styles from './MessageAuthor.module.scss';

interface MessageAuthorProps {
    author: string;
    isUser: boolean;
}

const MessageAuthor: React.FC<MessageAuthorProps> = ({ author, isUser }) => {
    const [personaProps, setPersonaProps] = useState<IPersonaSharedProps>();
    const getInitials = (name: string): string => {
        return name.split(' ').slice(0, 2)
            .map(word => word.charAt(0).toUpperCase()).join("");
    };

    const getProfilePhoto = async (graphInstance: MSGraphService) => {
        try {
            const photo = await graphInstance.getProfilePhoto();

            if (!photo) return "";  // Handle case where user does not have a photo
            return URL.createObjectURL(photo);

        } catch (error) {
           console.log(error);
        }
    };


    useEffect(() => {
        const fetchPersonaProps = async () => {
            const imageUrl = await getProfilePhoto(graphInstance);
            setPersonaProps({
                imageInitials: getInitials(author),
                size: PersonaSize.size24,
                imageAlt: author || "",
                imageUrl: imageUrl || ""
            });
        };
        fetchPersonaProps();
    }, [author,isUser]);

    return (

        <Stack grow={5}>
            {isUser ? (

                <Persona {...personaProps} />
            ) : (
                <Icon iconName="ChatBot" className={styles.chatBotIcon} />
            )}
        </Stack>
    );
};

export default MessageAuthor;
